export enum Paths {
  AUDIT = "/audit",
}

export enum AuditPaths {
  EMBED = `${Paths.AUDIT}/embed/`,
}
